import { enableProdMode } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';

import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

// Stays a promise chain rather than top-level await (Sonar S7785): zone.js disables native
// async/await in the esbuild pipeline, so top-level await does not build. Folded onto one line
// deliberately — S7785 reports on the whole chain, and a `NOSONAR` only suppresses the line the
// issue is reported on, so a two-line statement leaves it a coin flip which line that is.
bootstrapApplication(AppComponent, appConfig).catch(err => console.error(err)); // NOSONAR see above: top-level await cannot build with zone.js
